import { createContext, useContext } from "react";
import { PartnerBranding } from "app/types/services/branding";
import { DEFAULT_BRAND_NAME, DEFAULT_LOGO, DEFAULT_SUPPORT_EMAIL, hasPartnerBranding } from "app/utils/apply-branding";

export interface BrandingContextValue {
  branding: PartnerBranding | null;
  isReady: boolean;
}

export const BrandingContext = createContext<BrandingContextValue>({
  branding: null,
  isReady: false,
});

export const useBranding = () => useContext(BrandingContext);

export const useIsPartnerBranded = (): boolean => hasPartnerBranding(useBranding().branding);

export const useBrandName = (): string => useBranding().branding?.brandName || DEFAULT_BRAND_NAME;

export const useBrandLogo = (): string => useBranding().branding?.brandLogoUrl || DEFAULT_LOGO;

export const useSupportEmail = (fallback: string = DEFAULT_SUPPORT_EMAIL): string =>
  useBranding().branding?.brandSupportEmail || fallback;

export const useTermsUrl = (): string | null => useBranding().branding?.tncUrl || null;

export const usePrivacyPolicyUrl = (): string | null => useBranding().branding?.privacyPolicyUrl || null;
